export enum RepositoryState {
  INACTIVE = 'INACTIVE',
  STARTING = 'STARTING',
  RUNNING = 'RUNNING',
  RESTARTING = 'RESTARTING',
  STOPPING = 'STOPPING'
}
